// extracted by mini-css-extract-plugin
export default {"container":"eba-z","productName":"fba-z","price":"gba-z","dimensions":"hba-z"};